import React, { useState } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { FormControlLabel, Switch, TextField, Typography, Box, Paper, Grid, Button } from '@material-ui/core';
import { Link } from 'react-router-dom';

import ServiceDealsTable from './service-deals-table';
import ViewWrapper from 'views/ViewWrapper';

const styles = theme => ({
  paper: {
    padding: theme.spacing(2),
  },
  title: {
    paddingBottom: theme.spacing(2),
  },
  actionRow: {
    display: 'flex',
    justifyContent: 'space-between',
    paddingBottom: theme.spacing(2),
  },
  actionButton: {
    marginRight: theme.spacing(1),
  },
  rightActionContianer: {
    textAlign: 'right',
  },
  toggleLabel: {
    marginRight: 0,
  },
  startLabel: {
    marginRight: theme.spacing(1),
  },
});

const ServiceDeal = ({ ...props }) => {
  const { classes } = props;
  const [activeOnly, setActiveOnly] = useState(false);
  const [search, setSearch] = useState('');

  return (
    <ViewWrapper>
      <Grid item xs={12}>
        <Paper className={classes.paper}>
          <Grid container spacing={1}>
            <Grid item xs={9}>
              <Typography className={classes.title} variant="h5">
                Service Deals
              </Typography>
            </Grid>
            <Grid item xs={3} textAlign="right" className={classes.rightActionContianer}>
              <Link className={classes.actionButton} to={'/service-deals/create'}>
                <Button variant="contained">Create Service Deal</Button>
              </Link>
            </Grid>
          </Grid>
          <Grid container spacing={1}>
            <Grid item xs={9}>
              <TextField
                label="Search with deal name"
                value={search}
                onChange={({ target: { value } }) => setSearch(value)}
              />
            </Grid>
            <Grid item xs={3} textAlign="right" className={classes.rightActionContianer}>
              <Box className={classes.startLabel} display="inline">
                Active Deals Only
              </Box>
              <FormControlLabel
                className={classes.toggleLabel}
                control={
                  <Switch
                    checked={activeOnly}
                    onChange={e => {
                      setActiveOnly(e.target.checked);
                    }}
                    name="activeOnly"
                    inputProps={{ 'aria-label': 'secondary checkbox' }}
                  />
                }
              />
            </Grid>
          </Grid>
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <ServiceDealsTable activeOnly={activeOnly} search={search} />
            </Grid>
          </Grid>
        </Paper>
      </Grid>
    </ViewWrapper>
  );
};

export default withStyles(styles)(ServiceDeal);
